export default "__VITE_ASSET__40fd84e3__"